<template>
	<div id="cscinspectiontank-main">
		<div class="row">
			<div class="col-sm-12">
				<div class="row mb-1">
					<div class="col-sm-7">
						<div class="d-flex align-items-center mb-2">
							<h4 class="m-0 me-4 text-capitalize">CSC inspection tank</h4>
							<a id="add_cscinspectiontank_btn" class="btn btn-success border-dark btn-sm" :href="this.docRoot+'/cscinspectiontank/add'" role="button" v-if="['0101', '1111'].indexOf(all_permissions) >= 0">Add</a>
						</div>
					</div>
				</div>
				<DataTableComponent :dataprops="dataprops" @view-object="viewCscInspectionTank" @edit-object="prepareEditCscInspectionTank" @toggle-object-status="toggleObjectStatus" @export-object="printCscInspectionTank"  @duplicate-object="duplicateObject"></DataTableComponent>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "CscInspectionTankmaster",
	props: ['current_user_id', 'all_permissions'],
	data(){
		return{
			dataprops: {
				id: 'cscinspectiontank-list',
				class: 'a',
				base_url: '/api/cscinspectiontank/',
				columns: [
					{ title: 'Tank No', property: 'tank_no', sortable: true, },
					{ title: 'Company Name', property: 'rel_company_id.name', alt_value: 'Not Specified', sortable: true, },
					{ title: 'Inspection Date', property: 'inspection_date', sortable: true, },
					{ title: 'Inspection Location Name', property: 'rel_inspection_location_id.name', alt_value: 'Not Specified', sortable: true, },
					{ title: 'Operator Lessor', property: 'operator_lessor', sortable: true, },
				],
				data_to_send: { current_user_id: this.current_user_id } ,
				reload: false,
				search_params: {
					columns: [
						{
							title: "Company Id",
							property: "company_id",
							type: "relation",
							source: { api: 'Company', id: 'id', value: 'name' } 
						},                        
						{
							title: "Inspection Date",
							property: "inspection_date",
							type: "text",
							
						},                        
						{
							title: "Inspection Location Id",
							property: "inspection_location_id",
							type: "relation",
							source: { api: 'InspectionLocation', id: 'id', value: 'name' } 
						},                        
						{
							title: "Operator Lessor",
							property: "operator_lessor",
							type: "text",
							
						},                        
						{
							title: "Tank No",
							property: "tank_no",
							type: "text",
							
						},                        
						{
							title: "Surveyor Id",
							property: "surveyor_id",
							type: "relation",
							source: { api: 'Surveyor', id: 'id', value: 'name' } 
						},
					]
				},
				search: 'simple',
			},
			addeditModal: null,
			viewModal: null,
			currentUser: siteUserObject,
			readCscInspectionTank: {},
			cscinspectiontankForAdd: {},
		}
	},
	methods: {
		canceladdedit(event){
			this.cscinspectiontankForAdd.closed = true;
		},
		prepareEditCscInspectionTank(cscinspectiontank){
			window.location = this.docRoot + '/cscinspectiontank/edit/' + cscinspectiontank.id;
		},
		viewCscInspectionTank(cscinspectiontank){
			window.location = this.docRoot + '/cscinspectiontank/view/' + cscinspectiontank.id;
		},
		prepareAddModal(obj){
			this.cscinspectiontankForAdd = Object.assign({});
		},
		saveCscInspectionTank(cscinspectiontankForAdd){
			var that = this;
			that.showLoading("Saving ...");
			axios.post(that.docRoot+'/cscinspectiontank/save', { cscinspectiontank: cscinspectiontankForAdd }).then(async function (response) {
				that.closeSwal();
				var status = response.data.status;
				if( status > 0 ){
					// Set the ID so that duplicate records will not be created
					that.cscinspectiontankForAdd.id = response.data.id;
					that.showToast('CSC Inspection Tank saved successfully', 'success', 'bottom', 3000);
					setTimeout(() => {
						that.dataprops.reload = true;
						that.showLoading("Loading ...");
					}, 1500);
				}
				else{
					that.showErrors("CSC Inspection Tank could not be saved successfully.", response.data.messages, "bottom", 3000);
				}
			})
			.catch(function (error) {
				console.log(error);
				that.closeSwal();
				that.showToast("CSC Inspection Tank could not be saved successfully.", "error", "bottom", 3000);
			});
		},
		duplicateObject(cscinspectiontank) {
			let that = this;
			this.showConfirm("Are you sure you want to create a duplicate of this record?", "Yes", "No").then((result) => {
				if (result.isConfirmed) {
					// Call AXIOS to duplicate the invoice and then open in EDIT Mode
					this.showLoading("Saving ...");
					axios.post(this.docRoot+'/cscinspectiontank/duplicate', { id: cscinspectiontank.id }).then(async function (response) {
						that.closeSwal();
						var status = response.data.status;
						if (status == 1) {
							var newId = response.data.id;
							// Ajax to submit
							that.showToast('Record duplicated successfully', 'success', 'bottom', 3000);
							setTimeout(() => {
								that.showLoading("Redirecting ...");
							}, 2000);
							setTimeout(() => {
								window.location = that.docRoot+'/cscinspectiontank/edit/' + newId+"?duplicate=1";
							}, 4000);
						}
					});
				}
			});
		},
		toggleObjectStatus(cscinspectiontank, status){
			var that = this;
			Swal.fire({
				icon: "question",
				html: "Do you really want to " + (status == 1 ? "activate" : "deactivate") + ' the CSC Inspection Tank record?',
				showCancelButton: true
			}).then((result) => {
				if (result.isConfirmed) {
					that.cscinspectiontankForAdd = cscinspectiontank;
					that.cscinspectiontankForAdd.status = status;
					that.cscinspectiontankForAdd.action = "status";
					that.saveCscInspectionTank(that.cscinspectiontankForAdd);
				}
			});
		},
		printCscInspectionTank(cscinspectiontank) {
			window.location = this.docRoot+'/cscinspectiontank/export-to-pdf/' + cscinspectiontank.id;
			this.showToast("Printing. Please wait ...", "success", "bottom", 3000);
		},
	},
	async mounted() {
	}
}
</script>
